import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import BackButton from "../../Components/BackButton";
import { toast } from "react-toastify";
import "./reviews.css";

export const ReviewDetail = () => {

  const { id } = useParams();
  const [review, setReview] = useState({});

  const token = localStorage.getItem("login");
  const apiUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchReviewDetail();
  }, []);

  const fetchReviewDetail = () => {
    document.querySelector(".loaderBox")?.classList.remove("d-none");

    fetch(`${apiUrl}/admin/reviews/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        document.querySelector(".loaderBox")?.classList.add("d-none");
        if (data.status && data.data) {
          setReview(data.data);
        } else {
          toast.error(data.message || "Review content not found", {
            toastId: "review-not-found"
          });
        }
      })
      .catch(err => {
        document.querySelector(".loaderBox")?.classList.add("d-none");
        console.log(err);
        toast.error("Failed to load review details", {
          toastId: "review-fetch-error"
        });
      });
  };

  const renderStatus = (status) => {
    if (status === 0) return <span className="badge bg-warning">Pending</span>;
    if (status === 1) return <span className="badge bg-success">Approved</span>;
    if (status === 2) return <span className="badge bg-danger">Rejected</span>;
    return null;
  };

  return (
    <DashboardLayout>
      <div className="dashCard">
        <h2 className="mainTitle">
          <BackButton />
          Review Detail
        </h2>

        <div className="row mt-4">
          <div className="col-md-4 mb-3">
            <p className="secondaryText">User Name</p>
            <p>{review?.name || "N/A"}</p>
          </div>

          <div className="col-md-4 mb-3">
            <p className="secondaryText">Email</p>
            <p>{review?.email || "N/A"}</p>
          </div>

          <div className="col-md-4 mb-3">
            <p className="secondaryText">Rating</p>
            <p>{"⭐".repeat(review?.rating || 0)}</p>
          </div>

          <div className="col-md-12 mb-3">
            <p className="secondaryText">Review</p>
            <p>{review?.review || "No content"}</p>
          </div>

          <div className="col-md-4 mb-3">
            <p className="secondaryText">Status</p>
            {renderStatus(review?.status)}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};